
import { productGroups } from "@/data/products";
import PricingPageHeader from "@/components/pricing/PricingPageHeader";
import PricingRequestForm from "@/components/pricing/PricingRequestForm";

const RequestPricing = () => {
  const mainGroups = productGroups.filter(group => 
    group.id === "avoip" || 
    group.id === "reax-control" || 
    group.id === "audio-products" ||
    group.id === "meeting-room" ||
    group.id === "hdbaset" ||
    group.id === "ipbaset"
  );

  return (
    <div className="container mx-auto px-4 py-16 max-w-3xl">
      <PricingPageHeader />
      <PricingRequestForm productGroups={mainGroups} />
    </div>
  );
};

export default RequestPricing;
